import { render, staticRenderFns } from "./PhotoJourneyCard.vue?vue&type=template&id=ee3f71a4&scoped=true"
import script from "./PhotoJourneyCard.vue?vue&type=script&lang=js"
export * from "./PhotoJourneyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3f71a4",
  null
  
)

export default component.exports